<template>
  <div class="sticky-wrapper">
    <div class="sticky-inner">
      <accept-decline :campaign="campaign" :owner="owner"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rightSide',
  components: {
    acceptDecline: () => import('@/views/components/invitation/acceptDecline.vue')
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
    owner: {
      required: true,
      type: Object,
    },
  },
};
</script>
<style lang="scss" scoped>
.sticky-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.sticky-inner {
  position: sticky;
  top: 10rem;
}
</style>